var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46 12.98L7.0675 10.5875C6.86583 10.3858 6.61833 10.285 6.325 10.285C6.03167 10.285 5.775 10.395 5.555 10.615C5.35333 10.8167 5.2525 11.0733 5.2525 11.385C5.2525 11.6967 5.35333 11.9533 5.555 12.155L8.69 15.29C8.89167 15.4917 9.14833 15.5925 9.46 15.5925C9.77167 15.5925 10.0283 15.4917 10.23 15.29L16.4725 9.0475C16.6742 8.84583 16.775 8.59833 16.775 8.305C16.775 8.01167 16.665 7.755 16.445 7.535C16.2433 7.33333 15.9867 7.2325 15.675 7.2325C15.3633 7.2325 15.1067 7.33333 14.905 7.535L9.46 12.98ZM11 22C9.47833 22 8.04833 21.7111 6.71 21.1332C5.37167 20.5561 4.2075 19.7725 3.2175 18.7825C2.2275 17.7925 1.44393 16.6283 0.8668 15.29C0.288933 13.9517 0 12.5217 0 11C0 9.47833 0.288933 8.04833 0.8668 6.71C1.44393 5.37167 2.2275 4.2075 3.2175 3.2175C4.2075 2.2275 5.37167 1.44357 6.71 0.8657C8.04833 0.288567 9.47833 0 11 0C12.5217 0 13.9517 0.288567 15.29 0.8657C16.6283 1.44357 17.7925 2.2275 18.7825 3.2175C19.7725 4.2075 20.5561 5.37167 21.1332 6.71C21.7111 8.04833 22 9.47833 22 11C22 12.5217 21.7111 13.9517 21.1332 15.29C20.5561 16.6283 19.7725 17.7925 18.7825 18.7825C17.7925 19.7725 16.6283 20.5561 15.29 21.1332C13.9517 21.7111 12.5217 22 11 22Z",
    fill: "#0055FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.aadcd6c1d41947cb7537baa6e796eab0.svg";
export { ForwardRef as ReactComponent };